module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.getRoleType === 99) ? _c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.goBackInfo
    }
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5 flex"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-right"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKeyword),
      expression: "searchKeyword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchKeyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKeyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.clickPage(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [(_vm.list) ? _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.list), function(item, k) {
    return _c('tr', {
      key: k
    }, [_c('td', {
      domProps: {
        "textContent": _vm._s(k + 1)
      }
    }), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": (_vm.webDomain + "menu/" + (item.id)),
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "w-100 rounded",
      attrs: {
        "src": item.image
      }
    })])]), _vm._v(" "), _c('td', {
      domProps: {
        "textContent": _vm._s(item.name || item.name_short)
      }
    }), _vm._v(" "), _c('td', [(_vm.getRoleType === 10) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'brandMenu',
          params: {
            brand_id: item.id
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-plus-square"
    }), _vm._v("\n                          配料庫\n                        ")])]) : _c('router-link', {
      attrs: {
        "to": {
          name: 'StoreMenuStep',
          params: {
            store_id: item.id
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-plus-square"
    }), _vm._v("\n                          配料庫\n                        ")])])], 1), _vm._v(" "), _c('td', [(_vm.getRoleType === 10) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'brandMenuTable',
          params: {
            brand_id: item.id
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-wrench"
    }), _vm._v("\n                          菜單建置\n                        ")])]) : _c('router-link', {
      attrs: {
        "to": {
          name: 'StoreMenuBuild',
          params: {
            brand_id: _vm.$route.params.brand_id,
            store_id: item.id
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-wrench"
    }), _vm._v("\n                          菜單建置\n                        ")])])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'StoreMenuImage',
          params: {
            brand_id: _vm.$route.params.brand_id,
            store_id: item.id
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-picture-o"
    }), _vm._v("\n                          圖片庫\n                        ")])])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'StoreMenuSetting',
          params: {
            brand_id: _vm.$route.params.brand_id,
            store_id: item.id
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-certificate"
    }), _vm._v("\n                          別名 / 描述 / 警語\n                        ")])])], 1), _vm._v(" "), _c('td', [(_vm.getRoleType === 10) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'brandScheduleTable',
          params: {
            brand_id: item.id,
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-primary"
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v("\n                          排程管理\n                        ")])]) : _c('router-link', {
      attrs: {
        "to": {
          name: 'StoreMenuSchedule',
          params: {
            brand_id: _vm.$route.params.brand_id,
            store_id: item.id
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-primary"
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v("\n                          排程管理\n                        ")])])], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('paginate', {
    ref: "brandPaginate",
    attrs: {
      "clickPage": _vm.clickPage,
      "groupAmount": _vm.paginate.count,
      "isActive": _vm.isActive,
      "pageAmount": _vm.pageAmount,
      "total": _vm.paginate.total
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-8 text-left"
  }, [_c('div', {
    staticClass: "font-size-subtitle-2 font-weight-regular"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("此區可新增、編輯品牌下所有菜單的內容")])]), _vm._v(" "), _c('div', {
    staticClass: "font-size-subtitle-2 font-weight-regular"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("黑名單：名單內的門市當進行配料庫複製時「不可」被覆寫，菜單上架時「不可」被複寫")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control h-38"
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("關鍵字")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "w-xl"
  }, [_vm._v("品牌")]), _vm._v(" "), _c('th', [_vm._v("門市")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7fb0a44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/store-menu.vue
// module id = 2560
// module chunks = 1